<template>
  <div class="history" id="jzdashiji">
    <div class="target-tt slidetop" v-animate-onscroll="'animateMove'">大事记</div>
    <div class="history-tab inner">
      <!-- <swiper :options="swiperOption" ref="mySwiper" v-if="HistoryData.length > 0">
        <swiper-slide class="history-slide" v-for="(item, index1) in HistoryData" :key="index1">
          <div class="history-line"></div>
        </swiper-slide>
      </swiper> -->
      <!-- <div class="history-arrow">
        <span class="iconfont prev">&#xe96e;</span>
        <span class="iconfont next">&#xe63c;</span>
      </div> -->
      <div class="history-list">
        <div class="history-items" v-for="(item, index1) in HistoryData" :key="index1">
          <div class="history-info1">
            <time>{{item.title.split("年")[0]}}年</time>
            <div class="history-text1">
              <p v-for="(item1, index2) in item.licheng" :key="index2">
                <b>{{item1[2]}}</b>
                <span v-html="item1[3].replace(/\n/g,'<br>')"></span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      HistoryData: {}
    }
  },
  methods: {
    async getData () {
      const { data: res } = await this.$http.get('/fdata/article_pagelist_show?catid=87')
      if (res.code === 1) {
        this.HistoryData = res.data.info
        console.log(this.HistoryData)
      }
    }
  },
  mounted () {
    this.getData()
  },
  components: {
  }
}
</script>

<style lang="less" scoped>
@import url("@/assets/css/about/index.less");
</style>
